import type { SVGProps } from 'react';
const SvgList = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'List Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M5.286 5.946H9.91M5.286 12.554H9.91M5.286 9.25h7.928M15.857 1.321H2.643c-.73 0-1.322.592-1.322 1.322v13.214c0 .73.592 1.322 1.322 1.322h13.214c.73 0 1.322-.592 1.322-1.322V2.643c0-.73-.592-1.322-1.322-1.322" />
    </g>
  </svg>
);
export default SvgList;
